/** Top portion of Lob A4 printed check image (check + remittance summary). */
export const PRINTED_CHECK_A4_CROP_FRACTION = 0.45

export function cropPrintedCheckTopBand(imageSrc: string): Promise<string> {
	return new Promise((resolve, reject) => {
		const img = new Image()
		img.onload = () => {
			const cropHeight = Math.max(1, Math.round(img.naturalHeight * PRINTED_CHECK_A4_CROP_FRACTION))
			const canvas = document.createElement("canvas")
			canvas.width = img.naturalWidth
			canvas.height = cropHeight
			const ctx = canvas.getContext("2d")
			if (!ctx) {
				reject(new Error("Canvas not supported"))
				return
			}
			ctx.drawImage(img, 0, 0, img.naturalWidth, cropHeight, 0, 0, img.naturalWidth, cropHeight)
			resolve(canvas.toDataURL("image/png"))
		}
		img.onerror = () => reject(new Error("Failed to load image for printed check crop"))
		img.src = imageSrc
	})
}
